import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Query from '../../requests/Articles/Query';
import { ResultType } from '../../types/ArticleTypes';
import Swal from 'sweetalert2';
import React from 'react';
import API_BASE_URL from '../../config';
import SearchInput from './SearchInput';
import ArticleList from './ArticleList';
import { Pagination } from './Pagination';

export type ArticleType = {
  _id: string;
  subheading: string;
  title: string;
  video?: string | null;
  content?: string | null;
  published: boolean;
  published_at: string;
  image: string;
};

type AllDataType = {
  articles: ArticleType[]; // Assuming ArticleType is another type you've defined
  totalPages: number; // Add totalPages property to match the expected structure
};

const Article = () => {
  const [data, setData] = useState<AllDataType>({articles: [], totalPages: 1});
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const LIMIT = 3; // Number of articles per page

  useEffect(() => {
    const fetchData = async () => {
      try {
        const configuration = {
          url: `${API_BASE_URL}/articles?page=${currentPage}&limit=${LIMIT}`,
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('jwt')}`,
          },
        }

        axios.request<AllDataType>(configuration).then(
          (res) => {
            setTotalPages(res.data.totalPages)
            setData({articles: res.data.articles, totalPages: res.data.totalPages});
          }
          ).catch((err) => {
            navigate('/login');
        });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [navigate, currentPage]); // Empty dependency array means this effect runs once on mount

  const handleSearchResults = (results: AllDataType) => {
    setData({ articles: results.articles, totalPages: totalPages });
  };

  const handleDelete = (id: string) => {

    Swal.fire({
      title: 'Cuidado',
      text: 'Quieres continuar y borrar el artículo?',
      icon: 'warning',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        const url = `/article/delete/${id}`;

        const configuration = {
          url: API_BASE_URL + url,
          method: 'delete',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('jwt')}`,
          },
          data: {
            id
          },
        }

        axios.request(configuration)
          .then(_result => {
            const updatedArticles: AllDataType = {
              articles: data!.articles.filter((article) => article._id !== id),
              totalPages: data!.totalPages // Ensure totalPages is included
            };
            setData(updatedArticles);
          })
          .catch(error => {
            console.log(error);
          });
        Swal.fire('Borrado!', 'El artículo no borró.', 'success');
      }
      else {
        Swal.fire('No se borró!', 'El artículo no se borró.', 'info');
      }
    })
  };

  const handlePublishArticle = (to_publish: string, articleId: string) => {
    const url = `/article/${articleId}/status`;

    const title = undefined;
    const subheading = undefined;
    const video = undefined;
    const content = undefined;
    const published = to_publish === 'true' ? true : false;
    const verb = 'patch';

    const query = new Query(url, verb, title, subheading, video, content, published);
      query.updatePublishedStatus().then((result: ResultType) => {
        setData((prevData) => ({
          ...prevData,
          articles: prevData.articles.map((article) =>
            article._id === articleId
              ? { ...article, published: !article.published }
              : article
          ),
        }));
      })
        .catch((error) => {
        console.error(error);
      });
  }

  return (
      <div className="container mx-auto">
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          
          <SearchInput onSearch={handleSearchResults}></SearchInput>
          <ArticleList articles={data.articles} onDelete={handleDelete} onPublish={handlePublishArticle}></ArticleList>
          
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={(page) => setCurrentPage(page)}></Pagination>
        </div>
      </div>
    )
}

export default Article
